import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { Map, Viewport } from 'react-leaflet';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

import { GoogleTileLayer, LinkButton, PlaceInput } from '../components';

import {
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Input,
  DialogContentText,
  CircularProgress
} from '@material-ui/core';
import { NewFarmProvider } from '../providers';

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    position: 'relative'
  },
  dialog: {
    minWidth: 500,
    minHeight: 400
  },
  map: {
    flex: 1
  }
});

const DEFAULT_COORDS: [number, number] = [-33.5363786, -60.4150435];

type MutateFn = () => void;

interface State {
  activeStep: number;
  coords: [number, number] | null;
  selectedPlace: string | null;
  farmName: string | null;
  farmId: string | null;
}

type Props = WithStyles & RouteComponentProps<any>;

class NewFarmFlow extends React.Component<Props, State> {
  state = {
    activeStep: 0,
    selectedPlace: null,
    coords: null,
    farmName: null,
    farmId: null
  };

  renderMap() {
    const { classes } = this.props;

    const viewport: Viewport = {
      center: this.state.coords || DEFAULT_COORDS,
      zoom: this.state.coords ? 10 : 8
    };

    return (
      <Map className={classes.map} viewport={viewport}>
        <GoogleTileLayer />
      </Map>
    );
  }

  handleSelectPlace = (key: string, coords: [number, number]) => {
    this.setState({ selectedPlace: key, coords });
  };

  handleFinish = async (mutateFn: MutateFn) => {
    await this.setState({ activeStep: 2 });
    mutateFn();
  };

  renderLocateStep() {
    const { classes } = this.props;
    const { selectedPlace, coords } = this.state;

    return (
      <>
        <DialogContent className={classes.dialog}>
          <PlaceInput
            selectedKey={selectedPlace}
            onResultsChange={() =>
              this.setState({ selectedPlace: null, coords: null })
            }
            onSelect={this.handleSelectPlace}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            disabled={!coords}
            onClick={() => this.setState({ activeStep: 1 })}
          >
            Continuar
          </Button>
        </DialogActions>
      </>
    );
  }

  renderNameStep(mutateFn: MutateFn) {
    const { classes } = this.props;
    const { farmName } = this.state;
    return (
      <>
        <DialogContent className={classes.dialog}>
          <Input
            fullWidth={true}
            placeholder="Nombre del campo"
            onChange={evt => this.setState({ farmName: evt.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            disabled={!farmName}
            onClick={() => this.handleFinish(mutateFn)}
          >
            Continuar
          </Button>
        </DialogActions>
      </>
    );
  }

  renderFinishStep(loading: boolean) {
    const { classes } = this.props;
    const { farmId } = this.state;
    return (
      <>
        <DialogContent className={classes.dialog}>
          {loading && <CircularProgress />}
          {farmId && (
            <DialogContentText>
              Su campo ha sido registrado! Para continuar, debemos definir los
              poligonos de sus lotes.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <LinkButton
            color="primary"
            disabled={loading || !farmId}
            to={`/newfield/${farmId}`}
          >
            Dibujar Lotes
          </LinkButton>
        </DialogActions>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    const { activeStep, farmName, coords } = this.state;

    return (
      <NewFarmProvider
        params={{ name: farmName, coords }}
        onCompleted={farm =>
          this.setState({ farmId: (farm && farm.id) || null })
        }
      >
        {(mutateFn, loading) => (
          <main className={classes.root}>
            <Dialog open={true}>
              <Stepper activeStep={this.state.activeStep}>
                <Step>
                  <StepLabel>Ubicacion</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Nombre</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Finalizar</StepLabel>
                </Step>
              </Stepper>
              {activeStep === 0 && this.renderLocateStep()}
              {activeStep === 1 && this.renderNameStep(mutateFn)}
              {activeStep === 2 && this.renderFinishStep(loading)}
            </Dialog>
            {this.renderMap()}
          </main>
        )}
      </NewFarmProvider>
    );
  }
}

export default withStyles(styles)(withRouter(NewFarmFlow));



// WEBPACK FOOTER //
// ./src/containers/NewFarmFlow.tsx